import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { FC } from 'react';

type SingleButtonDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message?: string;
  confirmLabel?: string;
};

const SingleButtonDialog: FC<SingleButtonDialogProps> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth='xs'>
      {props.message && (
        <DialogTitle
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {props.message}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Button variant='contained' component='label' onClick={props.onConfirm}>
          {props.confirmLabel || 'OK'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default SingleButtonDialog;
